import {scaffolderPlugin} from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  CustomFieldExtensionSchema,
} from '@backstage/plugin-scaffolder-react';
import {FormFieldBlueprint, createFormField} from '@backstage/plugin-scaffolder-react/alpha';
import {FullNameField} from './FullNameField';

const FullNameExtensionSchema: CustomFieldExtensionSchema = {
  uiOptions: {
    type: 'object',
    properties: {},
  },
  returnValue: {
    type: 'string',
  },
};

const fullNameFormField = createFormField({
  name: 'FullNameExtension',
  component: FullNameField as any,
  schema: FullNameExtensionSchema as any,
});

export const FullNameExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'FullNameExtension',
    component: FullNameField,
    schema: FullNameExtensionSchema,
  }),
);

export const fullNameFieldExtension = FormFieldBlueprint.make({
  name: 'full-name-extension',
  params: {
    field: async () => fullNameFormField,
  },
});
